import { render, staticRenderFns } from "./leave-office.vue?vue&type=template&id=8ebef098&scoped=true"
import script from "./leave-office.vue?vue&type=script&lang=ts"
export * from "./leave-office.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ebef098",
  null
  
)

export default component.exports